"use client";
import React from "react";
import parse from "html-react-parser";
import InfoPart from "./InfoPart";
import CameraSlider from "./CameraSlider";

const shortcodeComponents = {
  "info-part": InfoPart,
  "image-side": CameraSlider,
};

export default function PostContentRenderer({ html }) {
  if (!html) return null;

  // Fix common escaped quotes
  const normalized = html.replace(/\\\"/g, '"').replace(/&quot;/g, '"');

  // Match ONLY [[info-part id="..."]] or [[image-side id="..."]]
  const shortcodeRegex =
    /\[\[\s*(info-part|image-side)\s+id\s*=\s*(?:\\?["'])?(\d+)(?:\\?["'])?\s*\]\]/g;

  const elements = [];
  let lastIndex = 0;
  let match;

  while ((match = shortcodeRegex.exec(normalized)) !== null) {
    const [shortcode, type, id] = match;

    // Push untouched HTML before the shortcode
    if (match.index > lastIndex) {
      elements.push(
        <React.Fragment key={`html-${lastIndex}`}>
          {parse(normalized.slice(lastIndex, match.index))}
        </React.Fragment>
      );
    }

    // Replace shortcode with the mapped React component
    const Component = shortcodeComponents[type];
    if (Component) {
      elements.push(<Component key={`${type}-${id}-${match.index}`} id={id} />);
    } else {
      // If something unexpected, keep the shortcode as plain text
      elements.push(
        <React.Fragment key={`literal-${match.index}`}>{shortcode}</React.Fragment>
      );
    }

    lastIndex = match.index + shortcode.length;
  }

  // Push the remaining HTML (if any) after the last shortcode
  if (lastIndex < normalized.length) {
    elements.push(
      <React.Fragment key={`html-end`}>
        {parse(normalized.slice(lastIndex))}
      </React.Fragment>
    );
  }

  return <>{elements}</>;
}
